<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Expressief lezen" [steps]="steps().length" [progress]="index()" />

  <rid-mechanic-content>
    @let title =
      {
        CAREFUL: 'Lees de tekst zorgvuldig voor',
        PUNCTUATION: "Let extra op de punten en komma's",
        EXPRESSIVE: 'Lees de tekst expressief voor',
      }[step().mode];

    @for (input of [title]; track input) {
      <rid-mechanic-title [title]="input" [animate.enter]="index() > 0 ? 'wait-500' : undefined" />
    }

    @for (input of [step()]; track input) {
      <div
        class="bg-card-background font-family-din absolute w-md rounded-md border-2 border-slate-300 p-4 text-2xl leading-relaxed"
        animate.enter="wait-500 anim-pop-in"
        animate.leave="wait-100 anim-fade-out"
      >
        @if (step().mode === 'PUNCTUATION') {
          <span [innerHTML]="highlightPunctuation(step().content)"></span>
        } @else {
          {{ step().content }}
        }
      </div>
    }

    @for (input of [step()]; track input) {
      @if (!$expressionService.isRolling()) {
        @if (step().evaluate) {
          <rid-voice-recorder
            class="absolute bottom-8"
            size="MEDIUM"
            animate.enter="wait-750 anim-pop-in"
            animate.leave="wait-100 anim-fade-out"
            (playedBack)="rate()"
          />
        } @else {
          <rid-bottom-button
            content="Volgende"
            animate.enter="wait-750 anim-pop-in"
            animate.leave="wait-100 anim-fade-out"
            (clicked)="next()"
          />
        }
      }
    }

    @if (isRating()) {
      @let ratingTitle =
        {
          CAREFUL: 'Hoe netjes heb je gelezen?',
          PUNCTUATION: "Hoe goed heb je op de punten en komma's gelet?",
          EXPRESSIVE: 'Hoe goed heb je gelezen?',
        }[step().mode];

      <rid-modal-background />
      <rid-rating-modal [title]="ratingTitle!" [starsOnly]="true" (continued)="handleRating()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
